/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Forside_Example_Download_FileInputs */

const da_forside_example_download_file = /** @type {(inputs: Forside_Example_Download_FileInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hent ${i?.name}`)
};

/** @type {(inputs: Forside_Example_Download_FileInputs) => LocalizedString} */
const en_forside_example_download_file = da_forside_example_download_file;

/**

* @param {Forside_Example_Download_FileInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_example_download_file = /** @type {((inputs: Forside_Example_Download_FileInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Example_Download_FileInputs, { locale?: "da" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_example_download_file(inputs)
	return da_forside_example_download_file(inputs)
});